
import { Component, Prop, Vue } from "vue-property-decorator";
import Booking from "@/domain/booking/Booking";
import FormService from "@/services/FormService";
import InternationalizationService from "@/services/InternationalizationService";
import PhoneInput from "@/components/PhoneInput.vue";
import { VuetifyForm } from "@/plugins/vuetify";
import SearchBookingDialog from "@/components/booking/search/SearchBookingDialog.vue";
@Component({
  components: { SearchBookingDialog, PhoneInput }
})
export default class BookingDetailsForm extends Vue {
  @Prop({ default: false })
  value!: boolean;

  @Prop({ default: null })
  booking!: Booking | null;

  @Prop({ default: false })
  hideSearch!: boolean;

  requiredString = [FormService.requiredStringRule];

  emailRule = [FormService.emailFormatRule];

  languages = InternationalizationService.selectLanguages;

  contactFormValid = false;

  detailsFormValid = false;

  defaultCountryCode = "";

  searchBookingDialog = false;

  created() {
    if (
      this.booking == null ||
      this.booking.phoneNumber == null ||
      this.booking.phoneNumber === ""
    ) {
      this.defaultCountryCode = this.$store.getters.getLocalCountryCode;
    }
  }

  async emitFormValid() {
    /* Ensures atleast one contact is set */
    const globalFormValid =
      this.detailsFormValid && this.contactFormValid && this.oneContactIsSet();
    this.$emit("input", globalFormValid);
  }

  set isContactFormValid(newVal: boolean) {
    this.contactFormValid = newVal;
    this.emitFormValid();
  }

  get isContactFormValid() {
    return this.contactFormValid;
  }

  set isDetailsFormValid(newVal: boolean) {
    this.detailsFormValid = newVal;
    this.emitFormValid();
  }

  get isDetailsFormValid() {
    return this.detailsFormValid;
  }

  get form() {
    return this.$refs.BookingDetailsForm as VuetifyForm;
  }

  async validateCustomerDetailsForm() {
    await this.form.validate();
    await this.emitFormValid();
  }

  get contactForm() {
    return this.$refs.ContactForm as VuetifyForm;
  }

  async validateContactForm() {
    await this.contactForm.validate();
    await this.emitFormValid();
  }

  oneContactIsSet() {
    console.log(this.booking?.phoneNumber);
    return (
      (this.booking?.email != null && this.booking.email !== "") ||
      (this.booking?.phoneNumber != null && this.booking.phoneNumber !== "")
    );
  }

  autoFillDetails(booking: Booking) {
    if (this.booking == null) {
      this.$store.dispatch("error", "Invalid booking in Details Form.");
      return;
    }
    this.booking.customerName = booking.customerName?.slice();
    this.booking.phoneNumber = booking.phoneNumber?.slice();
    this.booking.email = booking.email?.slice();
    this.validateCustomerDetailsForm();
    this.validateContactForm();
    console.log(this.booking.phoneNumber);
    console.log(this.oneContactIsSet());
  }
}
